<template>
  <fwb-card
    img-alt="Desk"
    variant="image"
    class="w-[346px] h-[367px] cursor-pointer"
  >
    <div class="w-full h-[184px] overflow-hidden">
      <div class="flex justify-between absolute px-4 py-3 w-[346px]">
        <div class="flex gap-1">
          <div>
            <span class="bg-custom_black2 flex text-white text-sm font-semibold rounded-md px-3 py-1 z-50">
              {{property.type_property_name}}
            </span>
          </div>
          <div>
            <LabelTag
              :label="property.type_movement_name"
              :type_movement_id="property.type_movement_id"
            />
          </div>
        </div>
        <!-- Dropdown menu-->
        <div class="relative">
          <button
            :id="`AddPropertyButton-${property.property_id}`"
            :data-dropdown-toggle="`AddPropertyDropdown-${property.property_id}`"
            class="inline-flex items-center p-1 text-sm font-medium text-center text-white bg-tuin-100 hover:bg-tuin_hover rounded-full focus:ring-0 focus:outline-none"
            type="button"
            @click="toggleDropdown(property.property_id)"
          > 
            <svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 3">
              <path d="M2 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm6.041 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM14 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"/>
            </svg>
          </button>

            <!-- Dropdown menu -->
          <div
            :id="`AddPropertyDropdown-${property.property_id}`"
            class="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow-lg w-48"
          >
            <ul
              class="py-2 text-sm text-custom_gray dark:text-gray-200"
              :aria-labelledby="`AddPropertyButton-${property.property_id}`"
            >
              <li v-if="property.status_id != null && property.status_id == 1">
                <a
                  href="#"
                  class="flex items-center font-medium gap-1 px-4 py-2 hover:text-gray-700"
                  @click="$emit('share', property); $event.stopPropagation()"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                    <path d="M13.5768 11.7506C13.0714 11.7528 12.5828 11.9387 12.1964 12.2756C12.156 12.2334 12.1115 12.1957 12.0634 12.1632L6.76943 9.29638C6.71613 9.27308 6.66042 9.25619 6.60339 9.24604C6.60948 9.18131 6.62252 9.11928 6.62252 9.05366C6.62252 9.04557 6.62252 9.03838 6.62252 9.03118C6.67974 9.025 6.73623 9.01295 6.79116 8.99522L11.9252 6.71631C11.976 6.68779 12.0238 6.65373 12.0677 6.61472C12.4287 6.9749 12.8989 7.19489 13.3988 7.23736C13.8987 7.27983 14.3974 7.14218 14.8104 6.84775C15.2233 6.55332 15.525 6.12024 15.6644 5.62197C15.8038 5.12369 15.7722 4.5909 15.575 4.11396C15.3779 3.63701 15.0272 3.24528 14.5826 3.00521C14.138 2.76514 13.6268 2.6915 13.1356 2.79679C12.6445 2.90208 12.2037 3.17981 11.888 3.58289C11.5723 3.98596 11.4012 4.48955 11.4036 5.00824C11.4032 5.01573 11.4032 5.02323 11.4036 5.03072C11.3463 5.0372 11.2898 5.04954 11.235 5.06758L6.10095 7.34559C6.0502 7.37433 6.00243 7.40837 5.95838 7.44718C5.65798 7.14068 5.27795 6.93101 4.8645 6.84365C4.45104 6.75629 4.02194 6.795 3.62936 6.95509C3.23678 7.11517 2.8976 7.38973 2.65306 7.74539C2.40851 8.10106 2.26912 8.52253 2.25183 8.95858C2.23454 9.39462 2.34008 9.82648 2.55564 10.2017C2.7712 10.5768 3.08749 10.8792 3.46608 11.072C3.84467 11.2648 4.26926 11.3397 4.68825 11.2877C5.10723 11.2356 5.50258 11.0588 5.82625 10.7788C5.86659 10.8211 5.91117 10.8587 5.95925 10.8912L11.2532 13.758C11.3055 13.7859 11.3606 13.8076 11.4175 13.8228C11.4175 13.8821 11.4001 13.9396 11.4001 14.0025C11.4001 14.4471 11.5276 14.8816 11.7664 15.2512C12.0052 15.6208 12.3446 15.9088 12.7417 16.0789C13.1388 16.249 13.5757 16.2935 13.9973 16.2068C14.4189 16.1201 14.8061 15.906 15.11 15.5917C15.414 15.2774 15.6209 14.877 15.7048 14.441C15.7886 14.005 15.7456 13.5532 15.5811 13.1425C15.4166 12.7318 15.1381 12.3808 14.7807 12.1339C14.4233 11.8869 14.0032 11.7551 13.5733 11.7551L13.5768 11.7506Z" fill="#737373"/>
                  </svg>
                  Compartir
                </a>
              </li>
              <li v-if="property.status_id === 1">
                <a
                  href="#"
                  class="flex items-center font-medium gap-1 px-4 py-2 hover:text-gray-700"
                  @click="$emit('open-prospects', property.property_id)"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 18 15" fill="none">
                    <path d="M16.75 14.0625C16.75 12.5383 15.2887 11.2424 13.25 10.7611M11.5 14.0625C11.5 12.1287 9.14975 10.5625 6.25 10.5625C3.35025 10.5625 1 12.1287 1 14.0625M11.5 7.9375C12.4283 7.9375 13.3185 7.56875 13.9749 6.91237C14.6313 6.256 15 5.36576 15 4.4375C15 3.50924 14.6313 2.619 13.9749 1.96263C13.3185 1.30625 12.4283 0.9375 11.5 0.9375M6.25 7.9375C5.32174 7.9375 4.4315 7.56875 3.77513 6.91237C3.11875 6.256 2.75 5.36576 2.75 4.4375C2.75 3.50924 3.11875 2.619 3.77513 1.96263C4.4315 1.30625 5.32174 0.9375 6.25 0.9375C7.17826 0.9375 8.0685 1.30625 8.72487 1.96263C9.38125 2.619 9.75 3.50924 9.75 4.4375C9.75 5.36576 9.38125 6.256 8.72487 6.91237C8.0685 7.56875 7.17826 7.9375 6.25 7.9375Z" stroke="#737373" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Asignar Prospecto
                </a>
              </li>
              <li v-if="!property.is_associated">
                <a
                  href="#"
                  class="flex items-center font-medium gap-1 px-4 py-2 hover:text-gray-700"
                  @click="$emit('edit', property.property_id)"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                    <path d="M13.9433 3.61003C14.3341 3.21928 14.8641 2.99976 15.4167 2.99976C15.9693 2.99976 16.4992 3.21928 16.89 3.61003C17.2808 4.00078 17.5003 4.53076 17.5003 5.08336C17.5003 5.63597 17.2808 6.16595 16.89 6.5567L15.64 7.8067L5.41667 18.03H2.5V15.0534L12.6933 4.86003L13.9433 3.61003Z" fill="#737373"/>
                    <path d="M12.6933 4.86003L15.64 7.8067M13.9433 3.61003C14.3341 3.21928 14.8641 2.99976 15.4167 2.99976C15.9693 2.99976 16.4992 3.21928 16.89 3.61003C17.2808 4.00078 17.5003 4.53076 17.5003 5.08336C17.5003 5.63597 17.2808 6.16595 16.89 6.5567L5.41667 18.03H2.5V15.0534L13.9433 3.61003Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Editar
                </a>
              </li>
              <li
                v-if="!property.is_associated && (property.status_id === 1 || property.status_id === 2)"
              >
                <a
                  href="#"
                  class="flex items-center font-medium gap-1 px-4 py-2 hover:text-gray-700"
                  @click="property.status_id === 2 ? ($emit('activate', { property_id: property.property_id, status: 1 }), closeDropdown(property.property_id)) : $emit('open-deactivate', property.property_id)"
                >
                  <!-- Si status_id === 1 (Activar) -->
                  <template v-if="property.status_id === 2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                      <path d="M7.29324 14C7.0974 14.0008 6.90902 13.918 6.7684 13.7693L3.22646 10.0197C3.15587 9.94453 3.09954 9.8549 3.06069 9.75596C3.02184 9.65702 3.00124 9.5507 3.00005 9.44307C2.99766 9.2257 3.07452 9.0162 3.21372 8.86065C3.35291 8.7051 3.54305 8.61625 3.74229 8.61365C3.94154 8.61104 4.13357 8.69489 4.27615 8.84674L7.29624 12.0426L13.7233 5.23293C13.8661 5.08107 14.0583 4.9973 14.2577 5.00007C14.4571 5.00283 14.6473 5.09189 14.7865 5.24765C14.9257 5.40341 15.0025 5.61312 14.9999 5.83064C14.9974 6.04816 14.9158 6.25568 14.773 6.40754L7.81809 13.7693C7.67747 13.918 7.48909 14.0008 7.29324 14Z" fill="#737373"/>
                    </svg>
                    Activar
                  </template>

                  <!-- Si status_id === 2 (Desactivar) -->
                  <template v-else-if="property.status_id === 1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                      <path d="M10.0586 9.5L14.0214 5.53721C14.0929 5.46814 14.15 5.38553 14.1892 5.29419C14.2285 5.20284 14.2491 5.1046 14.25 5.00519C14.2508 4.90578 14.2319 4.80719 14.1942 4.71518C14.1566 4.62317 14.101 4.53958 14.0307 4.46928C13.9604 4.39899 13.8768 4.3434 13.7848 4.30575C13.6928 4.26811 13.5942 4.24916 13.4948 4.25003C13.3954 4.25089 13.2972 4.27155 13.2058 4.31078C13.1145 4.35002 13.0319 4.40706 12.9628 4.47857L9 8.44136L5.03721 4.47857C4.896 4.34219 4.70688 4.26672 4.51058 4.26843C4.31428 4.27013 4.1265 4.34887 3.98768 4.48768C3.84887 4.6265 3.77013 4.81428 3.76843 5.01058C3.76672 5.20688 3.84219 5.396 3.97857 5.53721L7.94136 9.5L3.97857 13.4628C3.90706 13.5319 3.85002 13.6145 3.81078 13.7058C3.77155 13.7972 3.75089 13.8954 3.75003 13.9948C3.74916 14.0942 3.76811 14.1928 3.80575 14.2848C3.8434 14.3768 3.89899 14.4604 3.96928 14.5307C4.03958 14.601 4.12317 14.6566 4.21518 14.6942C4.30719 14.7319 4.40578 14.7508 4.50519 14.75C4.6046 14.7491 4.70284 14.7285 4.79419 14.6892C4.88553 14.65 4.96814 14.5929 5.03721 14.5214L9 10.5586L12.9628 14.5214C13.104 14.6578 13.2931 14.7333 13.4894 14.7316C13.6857 14.7299 13.8735 14.6511 14.0123 14.5123C14.1511 14.3735 14.2299 14.1857 14.2316 13.9894C14.2333 13.7931 14.1578 13.604 14.0214 13.4628L10.0586 9.5Z" fill="#737373"/>
                    </svg>
                    Desactivar
                  </template>
                </a>
              </li>
              <li v-if="property.is_associated">
                <a
                  href="#"
                  class="flex items-center font-medium gap-1 px-4 py-2 hover:text-gray-700"
                  @click="$emit('remove', property.property_id)"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                    <path d="M8.33398 9.66667V14.6667M11.6673 9.66667V14.6667M3.33398 6.33333H16.6673M15.834 6.33333L15.1115 16.4517C15.0816 16.8722 14.8934 17.2657 14.5849 17.553C14.2764 17.8403 13.8705 18 13.449 18H6.55232C6.13077 18 5.72487 17.8403 5.41639 17.553C5.1079 17.2657 4.91975 16.8722 4.88982 16.4517L4.16732 6.33333H15.834ZM12.5007 6.33333V3.83333C12.5007 3.61232 12.4129 3.40036 12.2566 3.24408C12.1003 3.0878 11.8883 3 11.6673 3H8.33398C8.11297 3 7.90101 3.0878 7.74473 3.24408C7.58845 3.40036 7.50065 3.61232 7.50065 3.83333V6.33333H12.5007Z" stroke="#737373" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Retirar Propiedad
                </a>
              </li>
              <li v-if="!property.is_associated">
                <a
                  href="#"
                  class="flex items-center font-medium gap-1 px-4 py-2 hover:text-gray-700"
                  @click="$emit('delete', property.property_id)"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                    <path d="M8.33398 9.66667V14.6667M11.6673 9.66667V14.6667M3.33398 6.33333H16.6673M15.834 6.33333L15.1115 16.4517C15.0816 16.8722 14.8934 17.2657 14.5849 17.553C14.2764 17.8403 13.8705 18 13.449 18H6.55232C6.13077 18 5.72487 17.8403 5.41639 17.553C5.1079 17.2657 4.91975 16.8722 4.88982 16.4517L4.16732 6.33333H15.834ZM12.5007 6.33333V3.83333C12.5007 3.61232 12.4129 3.40036 12.2566 3.24408C12.1003 3.0878 11.8883 3 11.6673 3H8.33398C8.11297 3 7.90101 3.0878 7.74473 3.24408C7.58845 3.40036 7.50065 3.61232 7.50065 3.83333V6.33333H12.5007Z" stroke="#737373" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Eliminar
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div 
        class="w-full h-52 overflow-hidden flex rounded-t-lg"
        :class="property.total_image == 0 ? 'justify-center items-center bg-[#f2f3f2]' : 'justify-end'"
      >
        <div 
          @click="$emit('go-to-detail', { property_id: property.property_id, is_associated: property.is_associated })"
        >
          <div
            v-if="property.total_image > 0"
            class="w-full h-[184px] bg-cover bg-center"
            :alt="property.property_name"
          >
            <img
              :src="property.image"
              :alt="property.property_name"
              class="w-full object-cover h-150 rounded-t-lg"
            />
          </div>

          <div v-if="property.total_image == 0">
            <img
              src="@/assets/imgs/default_image.svg"
              :alt="property.property_name"
              class="w-full h-28 object-cover rounded-t-lg"
            />
          </div>
        </div>
      </div>
    </div>
    <!---->

    <div 
      @click="$emit('go-to-detail', { property_id: property.property_id, is_associated: property.is_associated })"
      class="py-2 px-4 h-[181px] flex flex-col">
      <div class="flex justify-between">
        <div class="w-1/2">
          <span :class="[
            'text-xs font-medium rounded-md px-2.5 py-0.5',
            property.status_id === 1
              ? 'bg-green-100 text-green-800'
            : property.status_id === 2
              ? 'bg-gray-100 text-gray-800'
            : 'bg-yellow-100 text-yellow-800'
          ]">
            {{ property.status_name }}
          </span>
        </div>
        <div class="w-1/2 text-right flex flex-col">
          <span class="text-[8px] text-custom_gray">ID de la propiedad</span>
          <span class="text-[10px] font-medium">{{ property.property_code }}</span>
        </div>
      </div>
      <div>
        <p 
          class="mt-0.5 text-base font-semibold text-black truncate overflow-hidden whitespace-nowrap"
          :title="property.property_name"
        >
          {{ property.property_name }}
        </p>
        
        <!-- Si es movimiento mixto (venta + renta) -->
        <div
          v-if="property.type_movement_id === 3"
          class="flex gap-2 text-black text-sm font-semibold mt-0.5"
        >
          <div class="w-1/2">
            {{ property.property_value }}
            <span class="text-xs font-normal">{{ property.currency_code || property.currency }}</span>
          </div>
          <div class="w-1/2">
             {{ property.rent_value }}
            <span class="text-xs font-normal">{{ property.currency_code || property.currency }}</span>
          </div>
        </div>
        <!-- Solo venta (1 o 5) -->
        <div
          v-else-if="property.type_movement_id === 1 || property.type_movement_id === 5"
          class="text-black text-sm font-semibold mt-0.5"
        >
          {{ property.property_value }}
          <span class="text-xs font-normal">{{ property.currency_code || property.currency }}</span>
        </div>
        <div
          v-else-if="property.type_movement_id === 2 || property.type_movement_id === 4"
          class="text-black text-sm font-semibold mt-0.5"
        >
          {{ property.rent_value }}
          <span class="text-xs font-normal">{{ property.currency_code || property.currency }}</span>
        </div>
        <!--Details-->
        <div class="flex mt-1">
          <div class="flex items-center mr-3">
            <img
              src="@/assets/imgs/icons/meters.svg"
              alt="metros construidos"
              width="11"
              class="shrink-0"
            />
            <span class="ml-1 text-xs">
              {{ Number(property.constructed_metres).toLocaleString('en-US') }} m<sup>2</sup>
            </span>
          </div>

          <div class="flex items-center mr-3">
            <img
              src="@/assets/imgs/icons/bedroom.svg"
              alt="habitaciones"
              width="15"
              class="shrink-0"
            />
            <span class="ml-1 text-xs">
              {{ property.bedrooms }} Recámaras
            </span>            
          </div>

          <div class="flex items-center">
            <img
              src="@/assets/imgs/icons/shower.svg"
              alt="baños"
              width="14"
              class="shrink-0"
            />
            <span class="ml-1 text-xs">
              {{ property.bathrooms }} Baños
            </span>
          </div>
        </div>

        <p 
          class="mb-1 flex items-center mt-1 text-xs font-normal text-black truncate overflow-hidden whitespace-nowrap"
          :title="property.property_address"
        >
          <img
            src="@/assets/imgs/icons/map-pin-outline.svg"
            alt="Ubicación"
            class="w-4 h-4 shrink-0"
          />
          <span class="truncate overflow-hidden whitespace-nowrap block w-full">
            {{ property.property_address != ", , " ? property.property_address : "" }}
          </span>
        </p>

        <div v-if="property.is_associated" class="flex" @click.stop>
          <span class="text-xs font-medium text-custom_gray truncate overflow-hidden whitespace-nowrap">Asesor: </span>
          <span
            class="ml-1 text-xs font-normal text-custom_gray truncate hover:text-tuin_hover overflow-hidden whitespace-nowrap cursor-pointer hover:underline transition"
            @click="$emit('open-agent', property)"
          >
            {{ property.agent_name }}
          </span>
        </div>
      </div>
      <!--Iconos clics-->
      <div
        class="grid grid-cols-5 sm:grid-cols-5 md:grid-cols-5 gap-2 mt-auto"
      >
        <div class="flex flex-col items-center text-sm cursor-pointer">
          <span class="hidden text-xs text-gray-500 mb-1">Prospectos</span>
          <ToolTipComponent placement="bottom">
            <template #content> Prospectos asignados </template>
            <div class="flex items-center">
              <svg class="float-left" xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 18 15" fill="none">
                <path d="M16.875 14.0625C16.875 12.5383 15.4137 11.2424 13.375 10.7611M11.625 14.0625C11.625 12.1287 9.27475 10.5625 6.375 10.5625C3.47525 10.5625 1.125 12.1287 1.125 14.0625M11.625 7.9375C12.5533 7.9375 13.4435 7.56875 14.0999 6.91237C14.7563 6.256 15.125 5.36576 15.125 4.4375C15.125 3.50924 14.7563 2.619 14.0999 1.96263C13.4435 1.30625 12.5533 0.9375 11.625 0.9375M6.375 7.9375C5.44674 7.9375 4.5565 7.56875 3.90013 6.91237C3.24375 6.256 2.875 5.36576 2.875 4.4375C2.875 3.50924 3.24375 2.619 3.90013 1.96263C4.5565 1.30625 5.44674 0.9375 6.375 0.9375C7.30326 0.9375 8.1935 1.30625 8.84987 1.96263C9.50625 2.619 9.875 3.50924 9.875 4.4375C9.875 5.36576 9.50625 6.256 8.84987 6.91237C8.1935 7.56875 7.30326 7.9375 6.375 7.9375Z" stroke="#FF4265" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <strong class="ml-2"> {{ property.total_leads }} </strong>
            </div>
          </ToolTipComponent>
        </div>

        <div class="flex flex-col items-center text-sm cursor-pointer">
          <span class="hidden text-xs text-gray-500 mb-1">Visitas</span>
          <ToolTipComponent placement="bottom">
            <template #content> Visitas a la propiedad </template>
            <svg class="float-left" xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
              <path d="M9.00465 11.3729C9.95054 11.3729 10.7531 11.0446 11.4122 10.388C12.0714 9.73138 12.4012 8.93415 12.4019 7.99631C12.4025 7.05846 12.0714 6.26246 11.4085 5.60831C10.7456 4.95415 9.94154 4.62708 8.99627 4.62708C8.05099 4.62708 7.24816 4.95538 6.58777 5.612C5.92738 6.26862 5.59749 7.06615 5.59811 8.00462C5.59873 8.94308 5.92986 9.73877 6.59149 10.3917C7.25312 11.0446 8.05751 11.3717 9.00465 11.3729ZM8.99999 10.4923C8.30174 10.4923 7.70838 10.2502 7.21992 9.76585C6.73145 9.28154 6.48691 8.69292 6.48629 8C6.48567 7.30708 6.73021 6.71877 7.21992 6.23508C7.70962 5.75138 8.30298 5.50892 8.99999 5.50769C9.697 5.50646 10.2907 5.74892 10.781 6.23508C11.2713 6.72123 11.5156 7.30954 11.5137 8C11.5118 8.69046 11.2676 9.27908 10.781 9.76585C10.2944 10.2526 9.70072 10.4948 8.99999 10.4923ZM8.99999 14C7.15909 14 5.47088 13.5169 3.93534 12.5508C2.39981 11.5846 1.15972 10.3188 0.215061 8.75323C0.137478 8.62585 0.0822384 8.50062 0.0493431 8.37754C0.0164477 8.25446 0 8.12831 0 7.99908C0 7.86984 0.0164477 7.74369 0.0493431 7.62061C0.0822384 7.49754 0.137478 7.37292 0.215061 7.24677C1.16034 5.68123 2.40043 4.41538 3.93534 3.44923C5.47025 2.48308 7.15847 2 8.99999 2C10.8415 2 12.5297 2.48308 14.0646 3.44923C15.5996 4.41538 16.84 5.68154 17.7859 7.24769C17.8634 7.37385 17.9187 7.49846 17.9516 7.62154C17.9845 7.74462 18.0006 7.87108 18 8.00092C17.9994 8.13077 17.9832 8.25692 17.9516 8.37938C17.9199 8.50185 17.8647 8.62646 17.7859 8.75323C16.8406 10.3194 15.6002 11.5855 14.0646 12.5517C12.5291 13.5178 10.8409 14.0006 8.99999 14ZM8.99999 13.0769C10.7534 13.0769 12.3634 12.6194 13.83 11.7043C15.2967 10.7892 16.4176 9.55446 17.1928 8C16.417 6.44615 15.2957 5.21169 13.8291 4.29662C12.3625 3.38154 10.7528 2.92369 8.99999 2.92308C7.24723 2.92246 5.63752 3.38031 4.17089 4.29662C2.70425 5.21292 1.58301 6.44738 0.807178 8C1.58301 9.55385 2.70425 10.7886 4.17089 11.7043C5.63752 12.62 7.24723 13.0775 8.99999 13.0769Z" fill="#FF4265"/>
            </svg>
            <strong class="ml-2">{{ property.total_views }}</strong>
          </ToolTipComponent>
        </div>

        <div class="flex flex-col items-center text-sm cursor-pointer">
          <span class="hidden text-xs text-gray-500 mb-1">Llamadas</span>
          <ToolTipComponent placement="bottom">
            <template #content> Clics en llamadas </template>
            <svg class="float-left" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
              <path d="M12.9719 10.9182L13.3139 10.5785L12.5196 9.78047L12.1791 10.1202L12.9719 10.9182ZM14.4606 10.436L15.8939 11.2152L16.4301 10.2267L14.9976 9.44822L14.4606 10.436ZM16.1691 12.7632L15.1041 13.823L15.8969 14.6202L16.9619 13.5612L16.1691 12.7632ZM14.4546 14.1635C13.3671 14.2655 10.5546 14.1747 7.50813 11.1462L6.71463 11.9435C10.0386 15.2487 13.2029 15.4107 14.5596 15.284L14.4546 14.1635ZM7.50813 11.1462C4.60488 8.25872 4.12338 5.83097 4.06338 4.77722L2.93988 4.84097C3.01488 6.16697 3.61113 8.85797 6.71463 11.9435L7.50813 11.1462ZM8.53938 6.51122L8.75463 6.29672L7.96263 5.49947L7.74738 5.71322L8.53938 6.51122ZM8.92563 3.57047L7.98063 2.30747L7.07988 2.98247L8.02488 4.24472L8.92563 3.57047ZM4.79988 2.03222L3.62238 3.20222L4.41588 4.00022L5.59263 2.83022L4.79988 2.03222ZM8.14338 6.11222C7.74588 5.71322 7.74588 5.71322 7.74588 5.71472H7.74438L7.74213 5.71772C7.70649 5.75366 7.67458 5.79311 7.64688 5.83547C7.60638 5.89547 7.56213 5.97422 7.52463 6.07397C7.43334 6.33146 7.41059 6.60828 7.45863 6.87722C7.55913 7.52597 8.00613 8.38322 9.15063 9.52172L9.94413 8.72372C8.87238 7.65872 8.61738 7.01072 8.57013 6.70472C8.54763 6.55922 8.57088 6.48722 8.57763 6.47072C8.58213 6.46072 8.58213 6.45922 8.57763 6.46622C8.57094 6.47657 8.56342 6.48635 8.55513 6.49547L8.54763 6.50297L8.54013 6.50972L8.14338 6.11222ZM9.15063 9.52172C10.2959 10.6602 11.1576 11.1042 11.8071 11.2032C12.1394 11.2542 12.4071 11.2137 12.6104 11.138C12.7242 11.0963 12.8306 11.0366 12.9254 10.961L12.9629 10.9272L12.9681 10.9227L12.9704 10.9205L12.9711 10.919C12.9711 10.919 12.9719 10.9182 12.5751 10.5192C12.1776 10.1202 12.1799 10.1195 12.1799 10.1195L12.1814 10.118L12.1829 10.1165L12.1874 10.1127L12.1949 10.1052L12.2234 10.0827C12.2304 10.0782 12.2286 10.0787 12.2181 10.0842C12.1994 10.091 12.1259 10.1142 11.9781 10.0917C11.6676 10.0437 11.0151 9.78872 9.94413 8.72372L9.15063 9.52172ZM7.98063 2.30672C7.21563 1.28672 5.71263 1.12472 4.79988 2.03222L5.59263 2.83022C5.99163 2.43347 6.69963 2.47472 7.07988 2.98247L7.98063 2.30672ZM4.06413 4.77797C4.04913 4.51847 4.16838 4.24697 4.41588 4.00097L3.62163 3.20297C3.21888 3.60347 2.90163 4.17047 2.93988 4.84097L4.06413 4.77797ZM15.1041 13.823C14.8986 14.0285 14.6766 14.144 14.4554 14.1642L14.5596 15.284C15.1109 15.2322 15.5616 14.9547 15.8976 14.621L15.1041 13.823ZM8.75463 6.29672C9.49338 5.56247 9.54813 4.40222 8.92638 3.57122L8.02563 4.24547C8.32788 4.64972 8.28288 5.17997 7.96188 5.50022L8.75463 6.29672ZM15.8946 11.216C16.5074 11.549 16.6026 12.3335 16.1699 12.764L16.9634 13.5612C17.9684 12.5615 17.6586 10.8942 16.4309 10.2275L15.8946 11.216ZM13.3139 10.5792C13.6019 10.2927 14.0654 10.2222 14.4614 10.4367L14.9984 9.44897C14.1854 9.00647 13.1774 9.12872 12.5204 9.78122L13.3139 10.5792Z" fill="#FF4265"/>
            </svg>
            <strong class="ml-2">{{ property.total_click_call }}</strong>
          </ToolTipComponent>
        </div>

        <div class="flex flex-col items-center text-sm cursor-pointer">
          <span class="hidden text-xs text-gray-500 mb-1">Compartidos</span>
          <ToolTipComponent placement="bottom">
            <template #content> Compartidos </template>
            <svg class="float-left" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M6.51233 10.0065C6.66383 9.70352 6.74933 9.36152 6.74933 9.00002C6.74933 8.63852 6.66383 8.29652 6.51233 7.99352M6.51233 10.0065C6.2856 10.4598 5.91248 10.8233 5.4534 11.038C4.99432 11.2528 4.47617 11.3063 3.98291 11.1898C3.48964 11.0733 3.05015 10.7937 2.73564 10.3963C2.42112 9.99884 2.25 9.50686 2.25 9.00002C2.25 8.49319 2.42112 8.00121 2.73564 7.60377C3.05015 7.20633 3.48964 6.92673 3.98291 6.81025C4.47617 6.69377 4.99432 6.74724 5.4534 6.962C5.91248 7.17676 6.2856 7.54023 6.51233 7.99352M6.51233 10.0065L11.4863 12.4935M6.51233 7.99352L11.4863 5.50652M11.4863 12.4935C11.2194 13.0274 11.1755 13.6455 11.3642 14.2117C11.553 14.778 11.9589 15.2461 12.4928 15.513C13.0267 15.78 13.6448 15.8239 14.211 15.6351C14.7773 15.4464 15.2454 15.0404 15.5123 14.5065C15.7793 13.9726 15.8232 13.3546 15.6344 12.7883C15.4457 12.2221 15.0397 11.754 14.5058 11.487C14.2415 11.3548 13.9537 11.276 13.6589 11.2551C13.3641 11.2341 13.068 11.2715 12.7876 11.3649C12.2214 11.5537 11.7533 11.9596 11.4863 12.4935ZM11.4863 5.50652C11.6185 5.77083 11.8014 6.00651 12.0247 6.20011C12.248 6.39371 12.5072 6.54144 12.7875 6.63487C13.0679 6.7283 13.3639 6.76559 13.6586 6.74462C13.9534 6.72365 14.2411 6.64483 14.5055 6.51265C14.7698 6.38047 15.0054 6.19754 15.199 5.97428C15.3926 5.75102 15.5404 5.49181 15.6338 5.21146C15.7272 4.93111 15.7645 4.6351 15.7435 4.34034C15.7226 4.04557 15.6438 3.75783 15.5116 3.49352C15.2446 2.95974 14.7766 2.55387 14.2104 2.36518C13.6442 2.1765 13.0262 2.22046 12.4925 2.4874C11.9587 2.75434 11.5528 3.22239 11.3641 3.78859C11.1754 4.35478 11.2194 4.97274 11.4863 5.50652Z" stroke="#FF4265" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <strong class="ml-2">{{ property.total_click_share }}</strong>
          </ToolTipComponent>
        </div>

        <div class="flex flex-col items-center text-sm cursor-pointer">
          <span class="hidden text-xs text-gray-500 mb-1">Whatsapp</span>
          <ToolTipComponent placement="bottom">
            <template #content> Clics en whatsapp </template>
            <svg class="float-left" xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
              <path d="M14.2871 4.18254C13.5994 3.48812 12.7804 2.93752 11.8777 2.56281C10.9751 2.18811 10.0069 1.9968 9.02961 2.00004C4.93461 2.00004 1.59711 5.33754 1.59711 9.43254C1.59711 10.745 1.94211 12.02 2.58711 13.145L1.53711 17L5.47461 15.965C6.56211 16.5575 7.78461 16.8725 9.02961 16.8725C13.1246 16.8725 16.4621 13.535 16.4621 9.44004C16.4621 7.45254 15.6896 5.58504 14.2871 4.18254ZM9.02961 15.6125C7.91961 15.6125 6.83211 15.3125 5.87961 14.75L5.65461 14.615L3.31461 15.23L3.93711 12.95L3.78711 12.7175C3.17027 11.7328 2.8428 10.5945 2.84211 9.43254C2.84211 6.02754 5.61711 3.25254 9.02211 3.25254C10.6721 3.25254 12.2246 3.89754 13.3871 5.06754C13.9628 5.64044 14.4191 6.32195 14.7293 7.07254C15.0396 7.82313 15.1978 8.62785 15.1946 9.44004C15.2096 12.845 12.4346 15.6125 9.02961 15.6125ZM12.4196 10.9925C12.2321 10.9025 11.3171 10.4525 11.1521 10.385C10.9796 10.325 10.8596 10.295 10.7321 10.475C10.6046 10.6625 10.2521 11.0825 10.1471 11.2025C10.0421 11.33 9.92961 11.345 9.74211 11.2475C9.55461 11.1575 8.95461 10.955 8.24961 10.325C7.69461 9.83004 7.32711 9.22254 7.21461 9.03504C7.10961 8.84754 7.19961 8.75004 7.29711 8.65254C7.37961 8.57004 7.48461 8.43504 7.57461 8.33004C7.66461 8.22504 7.70211 8.14254 7.76211 8.02254C7.82211 7.89504 7.79211 7.79004 7.74711 7.70004C7.70211 7.61004 7.32711 6.69504 7.17711 6.32004C7.02711 5.96004 6.86961 6.00504 6.75711 5.99754H6.39711C6.26961 5.99754 6.07461 6.04254 5.90211 6.23004C5.73711 6.41754 5.25711 6.86754 5.25711 7.78254C5.25711 8.69754 5.92461 9.58254 6.01461 9.70254C6.10461 9.83004 7.32711 11.705 9.18711 12.5075C9.62961 12.7025 9.97461 12.815 10.2446 12.8975C10.6871 13.04 11.0921 13.0175 11.4146 12.9725C11.7746 12.92 12.5171 12.5225 12.6671 12.0875C12.8246 11.6525 12.8246 11.285 12.7721 11.2025C12.7196 11.12 12.6071 11.0825 12.4196 10.9925Z" fill="#FF4265"/>
            </svg>
            <strong class="ml-2">{{ property.total_click_wp }}</strong>
          </ToolTipComponent>
        </div>
      </div>
      <!--Iconos clics-->
    </div>
  </fwb-card>
</template>

<script setup>
import { ref, nextTick } from "vue";
import { FwbCard } from "flowbite-vue";
import ToolTipComponent from "@/components/common/ToolTipComponent.vue";
import LabelTag from "@/commond/LabelTag.vue";

defineProps({
  property: {
    type: Object,
    required: true
  }
});

defineEmits(['share', 'open-prospects', 'edit', 'activate', 'open-deactivate', 'remove', 'delete', 'go-to-detail', 'open-agent']);

const dropdownInstances = ref({});

function toggleDropdown(propertyId) {
  nextTick(() => {
    const targetEl = document.getElementById(`AddPropertyDropdown-${propertyId}`);
    const triggerEl = document.getElementById(`AddPropertyButton-${propertyId}`);

    if (targetEl && triggerEl) {
      import('flowbite').then(({ Dropdown }) => {
        if (dropdownInstances.value[propertyId]) {
          dropdownInstances.value[propertyId].hide();
          delete dropdownInstances.value[propertyId];
        }

        const instance = new Dropdown(targetEl, triggerEl, {
          placement: 'bottom-end',
          triggerType: 'click',
          offsetSkidding: 0,
          offsetDistance: 10,
          delay: 100,
        });

        dropdownInstances.value[propertyId] = instance;
        instance.show();
      });
    }
  });
}

function closeDropdown(propertyId) {
  if (dropdownInstances.value[propertyId]) {
    dropdownInstances.value[propertyId].hide();
    delete dropdownInstances.value[propertyId];
  }
}
</script>
